<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/marketforecast',title:'周预测'},{title:'市场预测'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="选择日期" style="width: 50%;">
                                <el-date-picker
                                        placeholder="请选择"
                                        v-model="q.searchDate"
                                        :clearable="false"
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="产品编码" style="width: 50%;">
                                <el-input v-model="q.productCode" placeholder="模糊查询"></el-input>
                            </el-form-item>
                            <el-form-item label="产品型号" style="width: 50%;">
                                <el-input v-model="q.productModel" placeholder="模糊查询"></el-input>
                            </el-form-item>
                            <el-form-item label="预测来源" style="width: 50%;">
                                <el-input v-model="q.forecastSource" placeholder="模糊查询"></el-input>
                            </el-form-item>
                            <el-form-item class="h-formBtnOut">
                                <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                                <el-button class="h-btn h-formBtn h-bgwhite" @click="reset">重置</el-button>
                            </el-form-item>
                        </div>

                    </el-form>
                </div>
            </div>


            <!--展示表格-->
            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        @selection-change="handleSelectionChange"
                        :border="true"
                        stripe
                        style="width: 100%"
                >
                    <el-table-column
                            type="selection"
                            fixed
                            width="40">
                    </el-table-column>
                    <el-table-column
                            type="index"
                            label="序号"
                            width="55">
                    </el-table-column>
                    <el-table-column
                            prop="forecastSource"
                            label="预测来源"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="productCode"
                            label="产品编码"
                            :width="flexColumnWidth('productCode', tableData)">
                    </el-table-column>
                    <el-table-column
                            prop="productModel"
                            label="产品型号"
                            :show-overflow-tooltip="true"
                            width="150">
                    </el-table-column>
<!--                    <el-table-column
                            prop="operatorCode"
                            label="操作人工号"
                            width="110">
                    </el-table-column>-->

                    <el-table-column
                            v-for="(weekInfo,index) in weekInfoList"
                            :key = "'weekColIndex'+index"
                            :prop="weekInfo.key"
                            :label="weekInfo.weekName"
                            :render-header="renderHeader"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="updateDateTime"
                            label="更新时间"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="operatorName"
                            label="操作人"
                            width="70">
                    </el-table-column>

<!--                    <el-table-column
                            fixed="right"
                            label="操作"
                            width="150"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    style="margin-left: 0.1rem;padding: 0;"
                                    @click="handleDelete(scope.row)"
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                            >
                                删除
                            </el-button>
                        </template>
                    </el-table-column>-->
                </el-table>
                <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                   @click="openUploadExcelDialog">批量导入
                        </el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportRqExcel()">批量导出
                        </el-button>
                        <upload-fore-cast-excel :visible.sync="uploadExcelDialogVisiable" v-if="uploadExcelDialogVisiable"
                                                clsname="bscMarketForecastImportExcel" :startrow="0" @downTemp="downTemp" @callback="uploadExcelFileCallback"/>
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export"
                                   @click="handleDelete">批量删除
                        </el-button>
                    </div>
                    <div class="h-pagination2 h-pageCenter">
                        <pagination :page="page" @query="query"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService';
    import UploadForeCastExcel from '../../../components/uploaddown/UploadForeCastExcel';
    import updownfile from '../../../utils/updownfile';

    export default {
        components: {
            //批量导入控件
            UploadForeCastExcel
        },
        data() {
            return {
                //是否打开导入框
                uploadExcelDialogVisiable: false,
                //查询属性
                page: {
                    //每页显示最大数量
                    pageSize: 10,
                    //当前所在页
                    pageNo: 1,
                    //总数量
                    total: 0
                },
                q: {
                    ...this.page,
                    //查询日期,根据此日期推算T+3到T+13周的年和周数
                    //获取T+3周到T+13周的周预测数量
                    searchDate: null,
                    //产品编码
                    productCode: null,
                    //预测来源
                    forecastSource: null
                },
                //table列表
                tableData: [],
                //获取根据日期查询的T+3周到T+13周信息
                weekInfoList: [],
                //表格勾选数据
                tableSelectedList:[],
            };
        },
        created() {
            this.query();
        },
        methods: {
            //分割T+3周到T+13周列名,将括号内的放入下一遍显示
            renderHeader(h, {column}) {
                let leftBracketIndex = column.label.indexOf('(');
                let firstLabel = column.label.substring(0, leftBracketIndex);
                let secondLabel = column.label.substring(leftBracketIndex, column.label.length);
                return [h('p', [
                    h('p', {}, firstLabel),
                    h('span', {}, secondLabel)
                ])];
            },
            //重置条件
            reset() {
                this.q = {};
                //重新进行搜索
                this.query();
            },
            //获取查询条件
            getSearchInfo() {
                let searchInfo = {};
                Object.assign(searchInfo, this.q);
                Object.assign(searchInfo, this.page);
                return searchInfo;
            },
            query() {
                let _self = this;
                let searchWeekInfo = _self.getSearchWeeksInfo();
                ss.MarketForecast.getCurTAfterWeeks(searchWeekInfo).then(res => {
                    _self.weekInfoList = res;
                    //获取查询条件
                    let searchInfo = _self.getSearchInfo();
                    ss.MarketForecast.selectPage(searchInfo).then(rd => {
                        _self.page.total = rd.total;
                        _self.tableData = rd.records;
                        for (let i = 0; i < this.tableData.length; i++) {
                            let marketForecast = this.tableData[i];
                            for (let j = 0; j < marketForecast.weekYieldList.length; j++) {
                                const weekYield = marketForecast.weekYieldList[j];
                                _self.$set(marketForecast, weekYield.tableColName, weekYield.quantity);
                            }
                        }
                    });
                });
            },
            //获取查询T+3周到T+13周的周信息
            getSearchWeeksInfo() {
                let searchInfo = {};
                //设置查询日期
                searchInfo.searchDate = this.q.searchDate;
                return searchInfo;
            },
            //打开批量导入窗口
            openUploadExcelDialog() {
                this.uploadExcelDialogVisiable = true;
            },
            //点击批量导入确定按钮触发功能
            uploadExcelFileCallback() {
                this.query();
            },
            //明细导出
            downTemp() {
                let search = {};
                updownfile.down(ss.MarketForecast.downExcelTempUrl, search, 'post', 'data');
            },
            //处理删除操作
/*            handleDelete(row) {
                this.$msg.confirm("将会删除选中日期对应的T+3周到T+13周周预测信息,删除不可逆,确认删除吗?",()=>{
                    if (row.weekYieldList) {
                        let delWeekYieldIdList = [];
                        for (let i = 0; i < row.weekYieldList.length; i++) {
                            const weekYield = row.weekYieldList[i];
                            delWeekYieldIdList.push(weekYield.id);
                        }
                        ss.MarketForecast.deleteBatchByIds(delWeekYieldIdList).then(res=>{
                            this.$msg.msgs(res.msg);
                            this.query();
                        });
                    }
                })

            },*/
            handleDelete() {
                this.$msg.confirm("将会删除选中日期对应的T+3周到T+13周周预测信息,删除不可逆,确认删除吗?",()=>{
                    let delWeekYieldIdList = [];
                    this.tableSelectedList.forEach((item, index) => {
                        if (item.weekYieldList) {
                            for (let i = 0; i < item.weekYieldList.length; i++) {
                                const weekYield = item.weekYieldList[i];
                                delWeekYieldIdList.push(weekYield.id);
                            }
                        }
                    })
                    if(delWeekYieldIdList){
                        ss.MarketForecast.deleteBatchByIds(delWeekYieldIdList).then(res => {
                            this.$msg.msgs(res.msg);
                            this.query();
                        });
                    }
                })

            },
            handleSelectionChange(lists){
                this.tableSelectedList = lists;
                var str = '';
                for(var i=0;i<lists.length;i++){
                    str += lists[i].sapCode + ',';
                }
                str = str.substring(0,str.length-1);
            },
            //产品编码列宽度自适应
            flexColumnWidth(str, tableData, flag = 'max') {
                str = str + ''
                let columnContent = ''
                if (!tableData || !tableData.length || tableData.length === 0 || tableData === undefined) {
                    return
                }
                if (!str || !str.length || str.length === 0 || str === undefined) {
                    return
                }
                if (flag === 'equal') {
                    for (let i = 0; i < tableData.length; i++) {
                        if (tableData[i][str].length > 0) {
                            columnContent = tableData[i][str]
                            break
                        }
                    }
                } else {
                    let index = 0
                    for (let i = 0; i < tableData.length; i++) {
                        if (tableData[i][str] === null) {
                            return
                        }
                        const now_temp = tableData[i][str] + ''
                        const max_temp = tableData[index][str] + ''
                        if (now_temp.length > max_temp.length) {
                            index = i
                        }
                    }
                    columnContent = tableData[index][str]
                }
                let flexWidth = 0
                for (const char of columnContent) {
                    if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
                        flexWidth += 14
                    } else if (char >= 'u4e00' && char <= 'u9fa5') {
                        flexWidth += 25
                    } else {
                        flexWidth += 8
                    }
                }
                if (flexWidth < 90) {
                    flexWidth = 90 //这个值可以自定义 最小值就是110
                }
                return flexWidth + 'px'
            },
            exportRqExcel(item){
                let _self = this;
                let searchWeekInfo = _self.getSearchWeeksInfo();
                ss.MarketForecast.getCurTAfterWeeks(searchWeekInfo).then(res => {
                    _self.weekInfoList = res;
                    //获取查询条件
                    let searchInfo = _self.getSearchInfo();
                    updownfile.down(ss.MarketForecast.downExcelUrl, searchInfo, 'post', 'searchInfo');
                });
            },
        }
    };
</script>